import { FullFooter } from '@/components/Footer';
import { Header } from '@/components/Header';
import { Box, Button, Container, Flex, Text } from '@chakra-ui/react';
import {
  Benefits,
  Collabs,
  ContactUs,
  Faq,
  Hero,
  Menu,
  MenuMobile,
  Packaging,
  Steps,
  TextBlock,
  UserMenu,
  Values,
} from '../components';

import 'keen-slider/keen-slider.min.css';
import { useTranslation } from 'react-i18next';
import { ScrollToTopButton } from '@/components/shared';
import { useStickyHeader } from '@/hooks';
import { ROUTE_PATHS } from '@/constants';

export const Landing: React.FC = (): JSX.Element => {
  const { t } = useTranslation();
  useStickyHeader();

  return (
    <>
      <Header>
        <Flex
          alignItems="center"
          gap={{ md: 6, lg: 8 }}
          grow={1}
          justifyContent={{ base: 'unset', md: 'center', xl: 'unset' }}
        >
          <Menu
            display={{ base: 'none', xl: 'flex' }}
            gap={{ base: 4, md: 6, lg: 12 }}
            id="main-nav"
          />
          <Button
            as="a"
            display={{ base: 'none', md: 'block' }}
            href={ROUTE_PATHS.manageDetails}
            variant="mbeSecondaryDark"
          >
            {t('LANDING.MENU.CTA')}
          </Button>
        </Flex>

        <UserMenu />
        <MenuMobile />
      </Header>
      <main>
        <Hero
          buttonText={t('LANDING.HERO.BUTTON_TEXT')}
          href="/quote/user"
          subtitle={t('LANDING.HERO.SUBTITLE')}
          title={t('LANDING.HERO.TITLE')}
        />
        <Container maxW="8xl">
          <Flex direction="column" justifyContent="space-evenly" my={{ base: 12, md: 32 }}>
            <TextBlock>{t('LANDING.TEXTBLOCKS.ONE')}</TextBlock>
            <Benefits />
            <Steps />
            <Packaging />
            <Values />
            <Collabs />
            <Faq />
            <Flex alignItems="center" direction="column" justifyContent="center">
              <Text fontSize="26px" fontWeight="normal" textAlign="center">
                {t('LANDING.TEXTBLOCKS.TWO')}
              </Text>
              <Box my={{ base: 8, md: 10 }}>
                <Button as="a" href="/quote/user" variant="mbePrimary">
                  {t('LANDING.TEXTBLOCKS.TWO_CTA')}
                </Button>
              </Box>
            </Flex>
          </Flex>
        </Container>
        <ContactUs />
      </main>
      <Box as="footer" bg="brand.sand" py={16}>
        <Container maxW="8xl">
          <FullFooter />
        </Container>
      </Box>
      <ScrollToTopButton
        bottom={10}
        direction="row-reverse"
        m="auto"
        maxW="8xl"
        mt={{ base: '-38px', md: '-48px' }}
        // eslint-disable-next-line @typescript-eslint/naming-convention
        paddingInline={{ base: 4, '2xl': 0 }}
        position="sticky"
        w="full"
      />
      <Box bg="white" position="relative" py={{ base: 6, md: 8 }}>
        <Container maxW="7xl">
          <Text fontSize="12px" textAlign="center">
            {t('LANDING.CREDITS')}
          </Text>
        </Container>
      </Box>
    </>
  );
};
